import { get } from 'lodash-es';

export const selectConfig = (state) => get(state, 'countryConfig');

export const selectFeatureConfig = (state, featureName) => {
  const config = get(state, 'countryConfig') || [];

  const selectedFeatureConfig = config.find((feature) => featureName === feature.name);
  return [!!selectedFeatureConfig, selectedFeatureConfig?.data || {}];
};

export const selectCountryConfig = (state) => selectConfig(get(state, 'country'));
export const selectCountryFeatureConfig = (state, featureName) => selectFeatureConfig(get(state, 'country'), featureName);
